import Vue from 'vue';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

Vue.mixin({
  methods: {
    onlyLetters(value) {
      if (!value) return '';
      return value.replace(/[^a-zA-ZÀ-ÿ\u00C0-\u017F]+/g, '');
    },
    onlyNumbers(value) {
      if (!value) return '';
      return value.replace(/\D+/g, '');
    },
    dateFormatter(_date, formatString = 'dd/MM/yyyy') {
      const date = new Date(_date);

      if (date instanceof Date && !isNaN(date)) {
        return format(date, formatString, { locale: ptBR });
      } else {
        return '';
      }
    },
    dateReferenceMonthFormatter(date, formatString = 'MM/yyyy') {
      if (date) {
        return format(new Date(date), formatString);
      } else {
        return ' - ';
      }
    },
    formatQueryParams(data) {
      let queryString = '';
      for (let [key, value] of Object.entries(data)) {
        if (value || value === false) {
          if (queryString === '') {
            queryString = `${queryString}?${key}=${value}`;
          } else {
            queryString = `${queryString}&${key}=${value}`;
          }
        }
      }
      return queryString;
    },

    signalNumber(num) {
      if (num > 0) {
        return true;
      } else if (num < 0) {
        return false;
      }
    },
    reverseDateString(date) {
      return date.split('-').reverse().join('-');
    },

    currencyFormatter(currency) {
      if (currency) {
        return currency.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
      } else {
        return 'R$ 0,00';
      }
    },

    numberToMonetary(number) {
      if (isNaN(number)) return '0,00';

      let negative = number < 0;
      number = Math.abs(number) / 100; // Convertendo centavos para reais

      return `${negative ? '-' : ''}${number.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },

    monetaryToNumber(monetaryString) {
      if (typeof monetaryString !== 'string') return 0;
      const removeDot = monetaryString.replace('.', '');

      const numericString = removeDot.replace(/[^\d,-]/g, '');
      //console.log({ numericString });

      const numberString = numericString.replace(',', '.');
      // console.log({ numberString });

      const result = parseFloat(numberString) * 100;
      //console.log({ result });

      //console.log({ final: Math.round(result * 100) / 100 });
      return Math.round(result * 100) / 100;
    },

    monetaryOnlyCommas(monetaryString) {
      let noCommaOrPointNumber = monetaryString.replace(/[,.]/g, '');
      let converted = parseFloat(noCommaOrPointNumber);
      console.log({ converted });
      return converted;
    },

    convertCurrencyToNumber(currencyString) {
      const cleanedString = currencyString.replace(/[^\d.,]/g, '');
      const numberString = cleanedString.replace(',', '.');
      const numberValue = parseFloat(numberString);
      return isNaN(numberValue) ? null : numberValue;
    },

    mascaraPhone(data) {
      var countString = data;
      if (countString) {
        if (countString.length == 11) {
          const parte1 = data.slice(0, 2);
          const parte2 = data.slice(2, 3);
          const parte3 = data.slice(3, 7);
          const parte4 = data.slice(7, 11);
          return (data = ` (${parte1}) ${parte2} ${parte3}-${parte4}`);
        } else {
          const parte1 = data.slice(0, 2);
          const parte2 = data.slice(2, 6);
          const parte3 = data.slice(6, 10);
          return (data = ` (${parte1}) ${parte2}-${parte3}`);
        }
      }
    },

    convertStringToNumber(str) {
      const cleanedStr = str.replace(/[^0-9,.]/g, '');
      const formattedStr = cleanedStr.replace(',', '.');
      const number = parseFloat(formattedStr, 10);
      return number;
    },

    isAdmin() {
      let verify = false;
      if (this.$store.getters.user) {
        const role = this.$store.getters.user.company_user.role;
        if (role.slug === 'admin') {
          verify = true;
        } else {
          this.$router.push({ name: 'error-404' });
        }
      }
      return verify;
    },
    isAdminOrDoctor() {
      let verify = false;
      if (this.$store.getters.user) {
        const role = this.$store.getters.user.company_user.role;
        if (role.slug === 'admin' || this.$store.getters.user.people.doctor) {
          verify = true;
        } else {
          this.$router.push({ name: 'error-404' });
        }
      }
      return verify;
    },
    // percentageFormatter(data) {
    //     return data.toString().replace('.', ',') + '%'
    // },

    // subString(text, size) {
    //     if (text.length > size)
    //         return text.substr(0, size) + '...'
    //     else
    //         return text
    // },

    onlyHours(dataString) {
      // Criar um objeto de data a partir da string fornecida
      const data = new Date(dataString);
      data.setHours(data.getHours() + 3);

      // Obter as horas e minutos da data
      const horas = data.getHours();
      const minutos = data.getMinutes();

      // Formatar as horas e minutos para o formato desejado (com zero à esquerda, se necessário)
      const horasFormatadas = horas < 10 ? '0' + horas : horas;
      const minutosFormatados = minutos < 10 ? '0' + minutos : minutos;

      // Retornar a string no formato "hh:mm"
      return `${horasFormatadas}:${minutosFormatados}`;
    },

    maskCpf(valor) {
      if (valor && valor.length === 11)
        //eslint-disable-line
        //eslint-disable-next-line
        return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    },
    formatCpfCnpj(value) {
      if (!value) return '';

      const numbers = value.replace(/\D/g, '');

      if (numbers.length <= 11) {
        return numbers
          .padStart(11, '0')
          .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (numbers.length <= 14) {
        return numbers
          .padStart(14, '0')
          .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }

      return value;
    },

    mascaraCnpj(valor) {
      //eslint-disable-line
      //eslint-disable-next-line
      return valor.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        '$1.$2.$3/$4-$5'
      );
    },
    generateHexColors(count) {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const r = Math.floor(255 * Math.random());
        const g = Math.floor(255 * Math.random());
        const b = Math.floor(255 * Math.random());

        const hex = `#${[r, g, b]
          .map((val) => val.toString(16).padStart(2, '0'))
          .join('')}`;
        colors.push(hex);
      }
      return colors;
    },
  },
});
